import { MediaImage, Spread } from 'editor/src/store/design/types';

const getImageElementsUsedInSpread = (spread: Spread) =>
  (spread.pages[0].groups.media?.filter((el) => el.type === 'image' && el.imageId) as MediaImage[]) || [];

export default getImageElementsUsedInSpread;
